export function buildQueryString(searchParams) {
    let customerId = searchParams.get("customerId");
    let productId = searchParams.get("productId");
    let showPage = searchParams.get("showPage");
    let successUrl = searchParams.get("successUrl");
    let goto = searchParams.get("goto");
    let errorMsg = searchParams.get("errorMsg");

    // Create an array to store the query parameters
    let queryParams = [];

    // Check if each variable has a value and add it to the queryParams array
    if (customerId) {
        queryParams.push(`customerId=${customerId}`);
    }

    if (productId) {
        queryParams.push(`productId=${productId}`);
    }

    if (showPage) {
        queryParams.push(`showPage=${showPage}`);
    }

    if (successUrl) {
        queryParams.push(`successUrl=${successUrl}`);
    }

    if (goto) {
        queryParams.push(`goto=${goto}`);
    }

    if (errorMsg) {
        queryParams.push(`errorMsg=${errorMsg}`);
    }

    let queryString = queryParams.join("&");

    if (queryString) {
        queryString = `?${queryString}`;
    }
    return queryString;
}
